import React from "react";

export const Wordmark = ({ size = "md", className = "" }) => {
  const config = {
    sm: { icon: 18, textClass: "text-base",  gap: "gap-2"   },
    md: { icon: 20, textClass: "text-xl",    gap: "gap-2.5" },
    lg: { icon: 28, textClass: "text-2xl",   gap: "gap-3"   },
  };
  const { icon, textClass, gap } = config[size];

  return (
    <div
      data-testid="nexus-wordmark"
      className={`font-display font-bold tracking-tight inline-flex items-center ${gap} ${textClass} ${className}`}
    >

      <svg width={icon} height={icon} viewBox="0 0 32 32" fill="none" aria-hidden="true">
        <rect width="32" height="32" rx="7" fill="#FF4F00" />
        <rect x="7" y="7" width="5" height="18" fill="white" />
        <rect x="20" y="7" width="5" height="18" fill="white" />
        {/* Clean parallelogram diagonal — no pinch, clearly reads as N */}
        <polygon points="12,7 16,7 20,25 16,25" fill="white" />
      </svg>

      {/* Wordmark — no trailing dot */}
      <span className="inline-flex items-baseline">
        <span className="text-white">nexus</span>
        <span className="text-[#7A9B9B]">-</span>
        <span className="text-white">vs</span>
      </span>
    </div>
  );
};

export default Wordmark;
